import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  history: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

class SimpleSearchFilter extends React.PureComponent {
  timeout = null;
  state = { value: this.props.query[this.props.name] || ""};

  handleSearch = ({ target }) => {
    const { query, history, name } = this.props;
    const value = target.value;
    this.setState({ value: value });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      history.replace({ search: query.stringify({ [name]: value, page: 1 }) });
    }, 200);
  }

  render() {
    const { placeholder, name } = this.props;
    return (
      <div className="subnav">
        <div className="subnav-searcher"><input type="search" name={name} placeholder={placeholder} value={this.state.value} onChange={this.handleSearch} /></div>
      </div>
    );
  }
}

SimpleSearchFilter.propTypes = propTypes;
export default SimpleSearchFilter;


// WEBPACK FOOTER //
// ./src/partialComponents/SimpleSearchFilter.jsx